<!--
 * @Author: scg
 * @Date: 2021-12-10 14:54:44
 * @LastEditTime: 2022-02-28 09:45:10
 * @LastEditors: scg
 * @Description:
-->
<template>
  <div class="fff">
    <div class="page_title">{{ list[s].title }}</div>
    <div class="Take" v-html="list[s].content"></div>
    <!-- <video v-if="video_url" :src="video_url" class="Allow"></video>
 -->
    <div class="Allow">
      <img :src="list[s].video_url" />
    </div>
    <div class="twoButton">
      <div
        @click="s == 5 ? (s = 4) : s == 4 ? (s = 3) : $router.go(-1)"
        class="BackButton"
      >
      {{$t('allow.back')}}
      </div>
      <div
        @click="
          s == 3
            ? (s = 4)
            : s == 4
            ? (s = 5)
            : $router.push({ name: 'Verification', params: $route.params })
        "
        class="loginButton"
      >
      {{$t('allow.continue')}}
      </div>
    </div>
  </div>
</template>

<script>
import { binddeviceGetIosStepDes } from '@/api/user'
export default {
  name: 'HelloWorld',
  data () {
    return {
      title: '',
      list: [
        {
          title: '',
          video_url: ''
        }
      ],
      s: 0,
      video_url: '',
      msg: ''
    }
  },
  mounted () {
    binddeviceGetIosStepDes().then((adj) => {
      console.log(adj)
      this.list = adj.data
      this.s = 3
    })
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff {
  width: 100%;
  position: absolute;
  height: 100%;
  background: #fff;
  overflow: hidden;
}
.Allow {
  font-size: 14px;
  color: grey;
  line-height: 20px;
  margin-left: 5%;
  width: 85%;
  max-width: 430px;
  border-radius: 12px;
  max-height: 300px;
  overflow: hidden;
}
.Allow img {
  width: 100%;
}
.Take {
  font-family: Noto Sans !important;
  font-size: 14px !important;
  color: #808080;
  font-weight: 400;
  margin-left: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/Allow.vue